import { defineMessages } from 'react-intl';

export default defineMessages({
    vehicleX: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.VEHICLE x',
        defaultMessage: 'VEHICLE {vehicleIndex}'
    },
    vehicleFinanceCategory: {
        id: 'ml.quoteandbind.common.vehicleInfo.Is the vehicle owned, financed or leased?',
        defaultMessage: 'Is the vehicle owned, financed or leased?'
    },
    namedNonOwner: {
        id: 'ml.quoteandbind.pa.additionalInformation.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    namedNonOwnerTooltipTitle: {
        id: 'ml.quoteandbind.pa.additionalInformation.Named Non-Owner.What is a Named Non-Owner policy?',
        defaultMessage: 'What is a Named Non-Owner policy?'
    },
    namedNonOwnerTooltipContent: {
        id: 'ml.quoteandbind.pa.additionalInformation.Named Non-Owner.tooltipContent',
        defaultMessage: 'A Named Non-Owner Coverage policy is for persons who do not own a vehicle or have one available for their use. This policy will provide Liability coverage when you drive a non-owned vehicle, whether that vehicle is borrowed or rented.'
    },
    serialNumber: {
        id: 'ml.quoteandbind.pa.additionalInformation.vehicle.Serial Number',
        defaultMessage: 'Serial Number'
    },
    enterSerialNumber: {
        id: 'ml.quoteandbind.pa.additionalInformation.vehicle.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    },
    gatewayVehicleX: {
        id: 'ml.quoteandbind.pa.vehiclevinlookup.(Vehicle #X)',
        defaultMessage: '(Vehicle #{vehicleIndex})'
    },
    costNewError: {
        id: 'ml.quoteandbind.pa.additionalInformation.costNew',
        defaultMessage: 'Please enter a value greater than 0.'
    }
});
